export const chartColors = [
    "#27427A",
    "#377ABD",
  ];
  